import keyMirror from 'keymirror';

export default keyMirror({
  ERROR_LOADING_PRODUCT_GROUP_DATA: null,
  LOAD_PRODUCT_GROUP: null,
  PRODUCT_GROUP_WAS_LOADED: null
});
